module.exports = __webpack_public_path__ + "img/7.60f0f5a7.jpeg";